import React from 'react';
import coverbackground from '../../assets/laundry.jpg';
import ReusableScrollCard from '../../components/ReusableScrollcard/ReusableScrollcard';

class ScrollLaundry extends React.Component {
  render () { 
   return(
  
  <ReusableScrollCard             
    
        
        description="Laundry"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollLaundry;